import BaseController from "confinus_ui/base_controller";
import { addParametersToQueryString } from "lib/util/add_parameter_to_url";

export default class DataTableHeaderCellController extends BaseController {
  public static values = {
    sortedDirection: { type: String, default: null },
    sortKey: { type: String, default: null },
  };

  declare private readonly sortedDirectionValue: string;
  declare private readonly sortKeyValue: string;
  public handleSortableClick() {
    const params = {
      // eslint-disable-next-line @typescript-eslint/camelcase
      sort_by: this.sortKey,
      // eslint-disable-next-line @typescript-eslint/camelcase
      sorted_direction: this.nextSortDirection,
    };
    window.location.search = addParametersToQueryString(
      window.location.search,
      params,
    );
  }

  private get sortKey() {
    return this.sortKeyValue;
  }

  private get sortDirection() {
    return this.sortedDirectionValue;
  }

  private get nextSortDirection() {
    return this.sortDirection === "desc" ? "asc" : "desc";
  }
}
